import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import serviceImg1 from '../../../Assets/ServiceRoute/service7.jpg';
import serviceImg2 from '../../../Assets/ServiceRoute/service8.jpg';
import './Detail.css';

const Detail = () => {
    return (
        <>
            <section className="healing p-5">
                <Container>
                    <Row className="align-items-center p-5">
                        <Col lg={6} sm={12} xs={12}>
                            <div className="physioText mt-5 mt-lg-0">
                                <h2 className="fw-bold">Fast Pain Relief : "Your <span>Path to Wellness</span>"</h2>
                                <p>Experience rapid relief from pain with our expert physiotherapy services. Whether you're dealing with persistent leg pain or troublesome joint discomfort, our skilled professionals tailor personalized treatments to swiftly alleviate your pain and restore your well-being. Your journey to comfort begins here.</p>
                                <p>Discover a new level of well-being as our dedicated physiotherapists specialize in swift pain relief. From targeted techniques for leg pain to tailored solutions for joint discomfort, we prioritize your comfort. Embrace a life free from pain – let us be your guide to rapid, effective relief.</p>
                            </div>
                        </Col>
                        <Col lg={6} sm={12} xs={12}>
                            <img src={serviceImg2} alt="Physiotherapist Service" className="img-fluid service-img" />
                        </Col>
                    </Row>
                </Container>
            </section>

            <section className="healing p-5 treatment-bg">
                <Container>
                    <Row className="align-items-center p-5">
                        <Col lg={6} sm={12} xs={12}>
                            <img src={serviceImg1} alt="expertDentist" className="img-fluid pt-xs-5" />
                        </Col>
                        <Col lg={6} sm={12} xs={12}>
                            <div className="physioText mt-5 mt-lg-0">
                                <h2 className="fw-bold text-white">Expert Care for a <span>Pain-Free Life</span></h2>
                                <p className="text-white">Experience specialized care for a range of physiotherapy concerns. Whether combating back pain or addressing muscle injuries, our dedicated team tailors effective treatments to your unique needs. Swift relief is our priority, guiding you towards a pain-free, revitalized life. Trust us to make your journey to well-being a seamless and comforting experience.</p>
                                <p className="text-white">Discover a world where physiotherapy transforms lives. From expertly managing chronic conditions to alleviating sports-related injuries, our skilled practitioners are committed to your recovery. Embrace a future with reduced pain and increased mobility. Your well-being is our mission, and we're here to empower you on the path to optimal health.</p>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>
        </>
    );
};

export default Detail;